import { render, staticRenderFns } from "./PowerView.vue?vue&type=template&id=3368953f&scoped=true&"
import script from "./PowerView.vue?vue&type=script&lang=ts&"
export * from "./PowerView.vue?vue&type=script&lang=ts&"
import style0 from "./PowerView.vue?vue&type=style&index=0&id=3368953f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3368953f",
  null
  
)

export default component.exports